import React, { Component } from 'react';
import Slider from "react-slick";
import renderHTML from 'react-render-html';

import { connect } from 'react-redux'
import { initLocation, DataSpreedshet } from './actions'



function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}


class CalendarContent extends Component {

  constructor(props){
    super(props)
    this.state = {
      day: [],
      activeIndex: 1,
      left: 0,
      strng: '',
      slideIndex: 0,
      nav1: null,
      nav2: null,
      dataobj:[],
      tagsel:12,
      excludeContry:['VE'],
      excludeCountryID:[19],
      excludeCountryInterID:[22],
      country: ''
    }
    this.dayofnumber = this.dayofnumber.bind(this)
    this.daysofmonths = this.daysofmonths.bind(this)
  }

  componentDidMount(){
    //this.props.getLocation()
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
    let arrayday = this.daysofmonths()
    this.setState({ 
      day: arrayday
    })
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      if(next_props.country.location === this.state.excludeContry[0]){
        this.props.getAlldataParrilla('1l7eaIIQFQAQ8ieaavqnpavdWP2TCjSglJZkuiGwiVFI', this.state.tagsel, 1)
      }else{
        this.props.getAlldataParrilla('1l7eaIIQFQAQ8ieaavqnpavdWP2TCjSglJZkuiGwiVFI', this.state.tagsel, 2)
      }
      this.setState({ 
        country: next_props.country.location
      })
    }
    if(next_props.parrilla.length !== this.state.dataobj.length){
      this.setState({ 
        dataobj: next_props.parrilla
      })

      this.state.day.map((item, i) =>{
        let parr = next_props.parrilla.filter((itempa) => {
          if(itempa.date){
            return parseInt(itempa.date[0], 10) === item.number
          }
          return false
        })
        item.data = parr
        return item
      })
    }
  }

  daysofmonths(){
    const dayObj = new Date();
    const dd = dayObj.getDate();
    const mm = dayObj.getMonth()+1;
    const yyyy = dayObj.getFullYear();
    const numberday = new Date(yyyy, mm, 0).getDate();
    let arraydata = []
    for (var i = 1 ; i <= numberday; i++) {
      let array = []
      array['name'] = this.dayofnumber(i, mm, yyyy)
      array['nameMonth'] = this.dayofmonth(i, mm, yyyy)
      array['nameYear'] = yyyy
      array['number'] = i
      array['data'] = []
      if (i === dd){
        array['active'] = true
      }else{
        array['active'] = false
      }
      arraydata.push(array)
    }

    this.setState({ 
      slideIndex: dd
    })

    this.slider1.slickGoTo((dd - 1))

    return arraydata
  }

  dayofnumber(day, mon, year){
    let dayArray=["domingo", "lunes", "martes", "miercoles", "jueves", "viernes", "sabado"]
    let daystring = new Date(mon+' '+day+', '+year+' 12:00:00')
    return dayArray[daystring.getUTCDay()]  
  }

  dayofmonth(day, mon, year){
    let dayArray=["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    let daystring = new Date(mon+' '+day+', '+year+' 12:00:00')
    return dayArray[(daystring.getUTCMonth())]  
  }


  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      swipeToSlide: true,
      adaptiveHeight: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      beforeChange: (current, next) => this.setState({ slideIndex: next })
    }
    return (
      <div className="cont-grid">
        <Slider asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)} focusOnSelect={true} {...settings}>
        {
          this.state.day.map((item, i) => {
            let active = (item.active) ? 'item-prog active' : 'item-prog'
            return(
              <div className={active} key={i}>
                <div className="prog-mont">{item.name}</div>
                <div className="prog-day">{item.number}</div>
              </div>
            )
          })
        }
        </Slider>

        <Slider asNavFor={this.state.nav1} ref={slider => (this.slider2 = slider)} adaptiveHeight={true} slidesToShow={1} swipeToSlide={true} focusOnSelect={true}>
        {
          this.state.day.map((item, i) => {
            let active = (item.active) ? 'item-prog active' : 'item-prog'
            return(
              <div className={active} key={i}>
                <div>
                  <div className="dayfech">
                    <h4>{item.name}</h4>
                    <p>{item.number} {item.nameMonth} {item.nameYear}</p>
                  </div>
                  <div className="contItems">
                    {
                      item.data.map((dataitem, i) => {
                        return(
                          dataitem.datapost.map((datapost, p) => {
                            let divStyle = {
                              backgroundImage: 'url(' + datapost.imgft_field + ')',
                            }
                            return(
                              <div className="itemCont" key={p}>
                                <a href={datapost.categoryLink}>
                                  <div className="itemContbg" style={divStyle}></div>
                                  <div className="title">{renderHTML(datapost.title.rendered)}</div>
                                  <div className="time">
                                    <span>{dataitem.hor}</span>
                                  </div>
                                  <div className="btn-more"><p>Ver más</p></div>
                                </a>
                              </div>
                            )
                          })
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            )
          })
        }
        </Slider>
      </div>
    )
  }
}


function mapStateToProps (reducer){
  return {
    parrilla: reducer.parrilla,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAlldataParrilla: (data, tag, page) => dispatch(DataSpreedshet(data,tag,page)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(CalendarContent)


// WEBPACK FOOTER //
// ./src/Calendarpro.js